import { FIXTURE_DETAILS_PATH } from '../fixture/paths';

/**
 * The engine's fixture tour (KPR-611): one of every step kind, pointing at
 * `fixture/FixtureTourPage.js`. The engine's tests run it and the screenshots
 * of the engine are taken from it. It is one of the only two sources the
 * loader accepts (the other is the welcome tour); it teaches nothing real.
 *
 * Its `page` names say which rendering of the fixture page each target is
 * checked against (`src/testUtils/tourTargets.js`).
 */
export const ENGINE_FIXTURE_TOUR_ID = 'engine-fixture';

const engineFixtureTour = {
	id: ENGINE_FIXTURE_TOUR_ID,
	version: 1,
	title: 'Engine fixture tour',
	audience: 'everyone',
	page: 'fixture',
	steps: [
		{
			id: 'hello',
			kind: 'info',
			title: 'A short walk through the page',
			text: 'Five stops, and you can leave at any time with Esc.',
		},
		{
			id: 'header',
			target: 'fixture-header',
			kind: 'info',
			title: 'The page header',
			text: 'The title of the page and its one filled action sit here.',
		},
		{
			id: 'add',
			target: 'fixture-add',
			kind: 'click',
			title: 'Add an item',
			text: 'Press Add item to open the form.',
		},
		{
			id: 'title',
			target: 'fixture-title',
			page: 'fixture-form',
			kind: 'type',
			title: 'Give it a title',
			text: 'Type a title. The tour moves on once you have.',
		},
		{
			id: 'managers',
			target: 'fixture-manager-note',
			kind: 'info',
			title: 'For managers',
			text: 'People who manage the collection see this note; everyone else skips this stop.',
			condition: (context) => context.canManage === true,
		},
		{
			id: 'details-link',
			target: 'fixture-details-link',
			kind: 'navigate',
			route: FIXTURE_DETAILS_PATH,
			title: 'Open the details view',
			text: 'Follow the link to see the record in full.',
		},
		{
			id: 'details',
			target: 'fixture-details-panel',
			page: 'fixture-details',
			kind: 'info',
			title: 'The details',
			text: 'Everything about the record is here.',
		},
		{
			id: 'goodbye',
			kind: 'info',
			title: 'That is the tour',
			text: 'Finish to close it. Start it again whenever you like.',
		},
	],
};

export default engineFixtureTour;
